import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0 3rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    max-width: ${({ size }) => (size ? `var(--max-container-width-${size})` : 'var(--max-container-width)')};
  }
  @media (${({ theme }) => theme.respondTo.desktop}) {
    padding: ${({ size }) => (size === 'small' ? '0 3rem' : '0 5rem')};
  }
`;

export default Container;
